import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import axios from 'axios';
import Header from 'components/UI/Header/Header';
import Footer from 'components/UI/Footer/Footer';
import Sections from 'components/sections/Sections';
import { Redirect } from "react-router-dom";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from 'react-loader-spinner';



const Techjob = props => {
    const [singleJob, setSingleJob] = useState({})
    const [genData, setGenData] = useState([])
    const [errorMessage, setErrorMessage] = useState("")
    const [isLoading, setIsLoading] = useState(true)
    const [isError, setIsError] = useState(true)

    
    useEffect(() => {
        fetchSingleJob(props.match.params.id);
      }, [props.match.params.id]);

    const fetchSingleJob = (id) => {
        //setIsLoading(true);
        axios.get(`https://newboardserver.herokuapp.com/alljobs/${id}/`)
        //axios.get(`http://localhost:8000/alljobs/${id}`)
        .then((response) => {
            console.log(response)
            response.data.job_description = response.data.job_description.replace(/[\[\]']/g,'' )
            response.data.job_description = response.data.job_description.replace(/â€™/g, "'")
            response.data.job_description = response.data.job_description.replace(/>,/g, ">")
            response.data.job_description = response.data.job_description.replace(/\r/g, "<br />")
            response.data.job_description = response.data.job_description.replace(/\\n/g, "")
            
            response.data.app_method = response.data.app_method.replace(/[\[\]']/g,'' )
            response.data.app_method = response.data.app_method.replace(/â€™/g, "'")
            response.data.app_method = response.data.app_method.replace(/>,/g, ">")
            response.data.app_method = response.data.app_method.replace(/",/g, "")
            response.data.app_method = response.data.app_method.replace(/\\r/g, "<br />")
            response.data.app_method = response.data.app_method.replace(/\\n/g, "")

            setSingleJob(response.data)
            setIsLoading(false);
            setIsError(false)
        })
        .catch(() => {
            setErrorMessage('Error while getting data, check your network connectivity and try again')
            setIsLoading(false);
        });
    };

    return(
        <div>
            <Header />
            <br/>
          <div class="page-container row">
          <div class="col-0 col-md-1"></div>
                <div class="col-12 col-md-10">                
                    {isLoading ? (<p align="center">Data loading, please wait.. 
                    <Loader type="ThreeDots" color="#00BFFF" height={50} width={50} />
                        </p>) : (
                            <div>
                                {isError ? (
                                    <div className="card col-11 col-md-9">
                                        <div align='center' className="card-header bg-default" ><h5><b>Page Error
                                            </b></h5>
                                        </div>
                                        <div class="card-body">
                                            <div>{errorMessage}</div>
                                        </div>
                                        <div class="card-footer bg-light" ></div>
                                    </div>
                                ) : (
                                    <div className="card col-11 col-md-9">
                                        <div align='center' className="card-header bg-default" ><h5><b>
                                            {singleJob.job_title} <br/> <span className="dateformat">{singleJob.string_date}</span>
                                            </b></h5>
                                        </div>
                                        <div class="card-body">
                                            <div>{singleJob.job_intro}</div>
                                            <div dangerouslySetInnerHTML={{ __html: singleJob.job_description }} />
                                            <div dangerouslySetInnerHTML={{ __html: singleJob.app_method}} />
                                        </div>
                                        <div class="card-footer bg-light"></div>
                                    </div>
                                )}
                            </div>
                    )}
                </div>
              <div class="col-0 col-md-1"></div>
            </div>
            <br/>
        <Footer />
      </div>
    );
  };
  
export default Techjob;